import React from "react";
import { Modal, Button, Upload } from "antd";

const PhotoUploadModal = ({
  open,
  photoFiles = [],
  photoUploading = false,
  onOk,
  onCancel,
  onUploadChange,
  onRemovePhoto,
  uploadButtonText = "Загрузить фото",
}) => {
  return (
    <Modal
      open={open}
      title="Требуется фото для списания"
      onOk={onOk}
      onCancel={onCancel}
      okButtonProps={{
        disabled: photoFiles.length === 0,
        loading: photoUploading,
      }}
      cancelButtonProps={{ disabled: photoUploading }}
    >
      <p>Для проведения документа списания требуется загрузить фотографию.</p>

      <Upload
        accept="image/*"
        multiple
        beforeUpload={() => false}
        showUploadList={false}
        onChange={onUploadChange}
        fileList={photoFiles}
        onRemove={(file) => {
          onRemovePhoto(file.uid);
          return false;
        }}
      >
        <Button>{uploadButtonText}</Button>
      </Upload>

      {photoFiles.map((file, index) => (
        <div
          key={file.uid || index}
          style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}
        >
          <img
            src={file.preview || file.url || ""}
            alt={file.name}
            style={{ maxWidth: 100, maxHeight: 100, objectFit: "contain" }}
          />
          <span style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis" }}>{file.name}</span>
          <Button danger onClick={() => onRemovePhoto(file.uid)} disabled={photoUploading}>
            Удалить
          </Button>
        </div>
      ))}
    </Modal>
  );
};


export default PhotoUploadModal;
